import React, { useContext } from 'react'
import { span } from '../../../style/span'
import { createUseStyles } from 'react-jss'
import theme from '../../../style/theme'
import { vw } from '../../../style/vw'
import Slider from '../../Slider'
import StarRating from './StarRating'
import Button from '../../Button'
import ColorContext from '../../ColorContext'

const FLICKITY_OPTIONS = {
  cellAlign: 'left',
  pageDots: false,
  contain: true,
  freeScroll: false
}

const Review = ({ data }) => {
  const { title, review, author, rating, cta } = data
  const link = cta?.[0]
  const { backgroundColor } = useContext(ColorContext)
  const classes = useStyles({ backgroundColor })

  return (
    <div className={classes.review}>
      <div className={classes.line} />
      <div className={classes.reviewRating}>
        <StarRating rating={rating} />
        <div>{rating?.toFixed(1)}</div>
      </div>
      <div className={classes.reviewTitle}>{title}</div>
      <div className={classes.reviewCopy}>
        {review}
        <div className={classes.reviewAuthor}>{author}</div>
      </div>
      {link && <Button link={link} size='sm' uppercase={false} />}
    </div>
  )
}

export default function ReviewSlice ({ slice }) {
  const { backgroundColor } = useContext(ColorContext)
  const classes = useStyles({ backgroundColor })

  return (
    <section>
      <div className={classes.sliderContainer}>
        <Slider title={slice.title} flickityOptions={FLICKITY_OPTIONS} reloadOnUpdate={false} withShadow>
          {slice.reviews?.map((review, i) => (
            <Review data={review} key={i} />
          ))}
          <div className={classes.blankTile} />
        </Slider>
      </div>
    </section>
  )
}

const useStyles = createUseStyles({
  section: {
    paddingLeft: span(1),
    paddingRight: span(1),
    [theme.breakpoints.up('md')]: {
      paddingLeft: span(1, 'md'),
      paddingRight: span(1, 'md')
    }
  },
  title: {
    fontSize: vw(30),
    marginBottom: vw(28),
    [theme.breakpoints.up('md')]: {
      fontSize: vw(48, 'desktop'),
      marginBottom: vw(58, 'desktop')
    }
  },
  review: {
    whiteSpace: 'wrap',
    width: '85%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    paddingRight: vw(20),
    marginRight: vw(20),
    position: 'relative',
    aspectRatio: '320 / 410',
    [theme.breakpoints.up('md')]: {
      width: vw(360, 'desktop'),
      paddingRight: vw(40, 'desktop'),
      marginRight: vw(40, 'desktop')
    }
  },
  line: {
    display: 'block',
    width: 1,
    opacity: 0.2,
    background: 'currentColor',
    right: 0,
    top: 0,
    bottom: 0,
    position: 'absolute'
  },
  reviewTitle: {
    fontFamily: theme.fonts.headings,
    fontWeight: 700,
    fontSize: vw(16),
    marginBottom: vw(30),
    [theme.breakpoints.up('md')]: {
      fontSize: vw(16, 'desktop'),
      marginBottom: vw(30, 'desktop')
    }
  },
  reviewRating: {
    display: 'flex',
    alignItems: 'start',
    gap: vw(12),
    fontFamily: theme.fonts.headings,
    fontSize: vw(13),
    marginBottom: vw(8),
    [theme.breakpoints.up('md')]: {
      gap: vw(12, 'desktop'),
      fontSize: vw(13, 'desktop'),
      marginBottom: vw(8, 'desktop')
    }
  },
  reviewCopy: {
    fontSize: vw(14),
    flexGrow: 1,
    flexShrink: 1,
    marginBottom: vw(16),
    whiteSpace: 'pre-wrap',
    [theme.breakpoints.up('md')]: {
      fontSize: vw(14, 'desktop'),
      marginBottom: vw(16, 'desktop')
    }
  },
  reviewAuthor: {
    fontFamily: theme.fonts.headings,
    fontSize: vw(14),
    marginTop: vw(20),
    [theme.breakpoints.up('md')]: {
      fontSize: vw(14, 'desktop'),
      marginTop: vw(20, 'desktop')
    }
  },
  blankTile: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block',
      width: vw(20, 'desktop')
    }
  },
  sliderContainer: {
    position: 'relative',
    overflow: 'hidden',
    paddingBottom: vw(140),
    [theme.breakpoints.up('md')]: {
      paddingBottom: vw(140, 'desktop')
    }
  }
})
